import Button from '@r1-frontend/ui-react/components/buttons/button';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Stepper from '@r1-frontend/ui-react/components/Stepper';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

interface IProps {
    quantity: number,
    onIncrement: () => void,
    onDecrement: () => void,
    onClose: () => void,
    minQuantity?: number,
    disabled?: boolean,
}

export const ControlsWithQuantity = ({
    quantity,
    minQuantity = 0,
    disabled = false,
    onIncrement,
    onDecrement,
    onClose,
}: IProps) => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return <>
        <Stepper
            min={minQuantity}
            summaryLimitsReached={disabled}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            value={quantity}
            $bgColor={COLORS.ButtonPrimary}
            $color={COLORS.TextWhite}
        />
        <Button
            bType={'secondary'}
            size={isMobile ? 'small' : 'medium'}
            onClick={onClose}
        >
            Продолжить оформление
        </Button>
    </>;
};
